/* eslint-disable react-hooks/exhaustive-deps */

/* Protopia Ecosystem component */

import { Button, ButtonGroup, ButtonVariant, Intent, Popover, Size, Tooltip } from "@blueprintjs/core"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingContent, ILandingSection, IToUp, LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import _toUp from "../../../../assets/img/to-up.svg"
import { useEffect, useState } from "react"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { __ } from "src/libs/utilities"
import { ScalableDialog, showToast } from "src/libs/useful"
import { DIALOG_SIZE } from "src/libs/interfaces/layouts"
import LandingCompositeDefault from "src/modules/pe-landing-module/widgets/composite/LandingCompositeDefault"
import updateHistory from "../utils/updateHistory"
import updateSection from "../utils/updateSection"

export const OFFLINE_SECTIONS: (LANDING_TYPE_CONTENT | string)[] = [
    LANDING_TYPE_CONTENT.DOTS_NAVIGATION,
    LANDING_TYPE_CONTENT.CONTACT_FORM,
    LANDING_TYPE_CONTENT.MODAL,
]
export interface IOfflineDataProps {
    section: ILandingSection
    data: ILandingContent
}
const OfflineSections = (): JSX.Element => {
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding)
    const getAllBtns = (): IOfflineDataProps[] => {
        let btn : IOfflineDataProps[] = []
        currentLanding.sections.forEach((sec: ILandingSection) => {
            if(!sec.isHidden) {
                sec.data.forEach((data: ILandingContent) => {
                    if(!data.isHidden && OFFLINE_SECTIONS.includes(data.type)) {
                        let isDisabled: boolean = false
                        if( data.type === LANDING_TYPE_CONTENT.CONTACT_FORM ) {
                            if( !data.isOverlayButton ) {
                                isDisabled = true
                            }
                        }
                        if( !isDisabled ) {
                            btn.push({
                                section: sec,
                                data
                            })
                        }
                    }
                })
            }
        })
        return btn 
    }
    const [btns, setBtns]           = useState<IOfflineDataProps[]>(getAllBtns())
    useEffect(() => {
        setBtns( getAllBtns() )
    }, [currentLanding])
    return <div 
        className='landing-offline' 
        style={{
            top: `calc(100dvh - ${ 100 /*+ 40 * (btns.length + (currentLanding.toUp.isEnable ? 1 : 0))*/ }px)`
        }}
    >
        {
            btns.map( btn => <MeatBtn btn={ btn } key={ btn.data.id } /> )
        }
       <ToUpEdit />
    </div>
}
export default OfflineSections

interface IMeatBtnProps {
    btn: IOfflineDataProps
}
const MeatBtn = ({btn, }: IMeatBtnProps): JSX.Element => {
    const [ isOpen, setIsOpen ] = useState<boolean>(false)
    const [ value, setValue]    = useState<any>( btn.data )
    const [ isDifferent, setIsDifferent]    = useState<boolean>( false )

    useEffect(() => {
        // setValue( btn.data )
    }, [ btn.data ])

    const onClick = () => {
        setIsOpen( !isOpen )
    }
    const onChange = ( val: any, field: string ) => {
        setValue( {
            ...value,
            [field]: val
        })
        setIsDifferent( true )
    }
    const onClose = () => { 
        setIsOpen(false)
        setValue( btn.data )
        setIsDifferent( false ) 
    }
    const onUpdate = () => { 
        if(updateSection(
            {
                ...btn.section,
                data: btn.section.data.map(meat => { 
                    return meat.id === value.id? value : meat
                })
            } as ILandingSection,
            {
                prevData: btn.data,
                data: value,
                type: HISTORY_TYPE.SECTION,
                title: "Update meat",
            } as IHistoryStep
        )) {
            setIsDifferent( false ) 
        }
        else {
            showToast({
                message: "Unknown error",
                intent: "danger"
            })
        }
        
    }
    return <>
        <Tooltip 
            content={ <div className="small letter-spacing-1 flex-centered">
                { __( components()[value.type]?.title ) } 
            </div> } 
            className=" ml-auto" 
            position="left"
            intent={ Intent.PRIMARY }
            compact
            hoverOpenDelay={ 600 }
            portalClassName="z-index-110"
            modifiers={{ 
                arrow: { enabled: true },
                flip: { enabled: true },
                preventOverflow: { enabled: false },
                offset: { 
                    enabled: true, 
                    options: {
                        offset: [0, 2],
                    } 
                }, 
            }}
        >
            <Button size={Size.LARGE} variant={ButtonVariant.OUTLINED} className="p-0" onClick={onClick}>
                <img src={ components()[value.type]?.icon } className="panel-icon"  alt="" />
            </Button>
        </Tooltip>
        <ScalableDialog
            isOpen={ isOpen }
            onClose={onClose}
            dialogSize={DIALOG_SIZE.NORMAL}
            title={ __( components()[value.type]?.title ) }
        > 
            <div className="max-height d-flex flex-column ">
                <div className="overflow-y-auto flex-grow-100">
                    <div className="p-0 min-height-300">
                        <LandingCompositeDefault
                            isAlwaysOpen
                            isNotCard
                            dataSection="Section"
                            dataName={ value.type }
                            type={ value.type }
                            value={ value }
                            onChange={onChange}
                        />
                    </div>
                </div>
                <ButtonGroup fill size="large">
                    <Button intent={Intent.SUCCESS} disabled={!isDifferent} onClick={onUpdate}>
                        { __("Update") }
                    </Button>
                    <Button intent={Intent.DANGER} disabled={!isDifferent}>
                        { __("Delete Meat") }
                    </Button>
                    <Button intent={Intent.NONE} onClick={onClose}>
                        { __("Cancel") }
                    </Button>
                </ButtonGroup>
            </div>
        </ScalableDialog>
    </>
}
const ToUpEdit = (): JSX.Element => {
    const currentLanding: ILanding = useLandingStore((state: ILandingStore) => state.currentLanding)
    const [value, setValue] = useState<IToUp>( currentLanding.toUp )
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const onClick = () => {
        setIsOpen( !isOpen )
    }
    const onChange = (_value: any, field: string, dop: any) => {
        setValue({
            ...value,
            [field]: _value
        })
    }
    const onUpdate = () => {
        const step: IHistoryStep = {
            type: HISTORY_TYPE.SETTINGS,
            data: value,
            prevData: currentLanding.toUp,
            title: "Update to Up button"
        }
        const newLanding = { ...currentLanding, toUp: value }
        updateHistory(
            step,
            newLanding
        )
        onClick()
    }
    if( currentLanding.toUp.isEnable ) {
        return <> 
            <Tooltip 
                content={ <div className="small letter-spacing-1 flex-centered">
                    {__( "Up-to-top button")} 
                </div> } 
                className=" ml-auto" 
                position="left"
                intent={ Intent.PRIMARY }
                compact
                hoverOpenDelay={ 600 }
                portalClassName="z-index-110"
                modifiers={{ 
                    arrow: { enabled: true },
                    flip: { enabled: true },
                    preventOverflow: { enabled: false },
                    offset: { 
                        enabled: true, 
                        options: {
                            offset: [0, 2],
                        } 
                    }, 
                }}
            >
                <Button size={Size.LARGE} variant={ButtonVariant.OUTLINED} className="p-0" onClick={onClick}>
                    <img src={_toUp} className="panel-icon"  alt="" />
                </Button>
            </Tooltip> 
            <ScalableDialog
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                dialogSize={DIALOG_SIZE.NORMAL}
                title={ __( "Up-to-top button" ) }
            >
                <div className="max-height d-flex flex-column ">
                    <div className="overflow-y-auto flex-grow-100">
                        <div className="p-0 min-height-200">
                            <LandingCompositeDefault
                                isAlwaysOpen
                                isNotCard
                                dataSection="Section"
                                dataName={ "ToUp" }
                                type={ "ToUp" }
                                value={ value }
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <ButtonGroup fill size="large" onClick={onUpdate}>
                        <Button intent={Intent.SUCCESS}>
                            { __("Update") }
                        </Button> 
                        <Button intent={Intent.NONE} onClick={() => setIsOpen(false)}>
                            { __("Cancel") }
                        </Button>
                    </ButtonGroup>
                </div>
            </ScalableDialog>
        </>
    }
    return <></>
}